import api from "./api";
import TokenService from "./token.service";

const register = (user) => {

  debugger
  return api.post("/user", {
    ...user
  });
};

const login = (username, password) => {
  return api
    .post("user_login", {
      username,
      password
    })
    .then((response) => {
      if (response.data.accessToken) {
        TokenService.setUser(response.data);
      }

      return response.data;
    });
};

const getUserRoles = (search) => {

  return api.get("/userrole",{
    params: {
      ...search
    }
  })
  .then((response) => {
    return response.data;
  });
};


const updateUserPassword = (userPassword) => {
  return api.post("/user_password",
  {
    ...userPassword
  })
  .then((response) => {
    return response.data;
  });
};

const getSessions = (page,pageSize) => {

  return api.get("/sessions?page="+page+"&pageSize="+pageSize)
  .then((response) => {
    return response.data;
  });
};

const updateSession = (id,isBlocked) => {

  return api.patch("/sessions",
  {
    id,
    isBlocked
  })
  .then((response) => {
    return response.data;
  });
};


const logout = () => {
  TokenService.removeUser();
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const AuthService = {
  register,
  login,
  logout,
  updateUserPassword,
  getCurrentUser,
  getSessions,
  updateSession,
  getUserRoles,
};

export default AuthService;